<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Enabled Vehicle Types')"
          icon="mdi-account-tie"
          class="px-3 py-3"
          color="primary"
        >
          <v-container>
            <v-app-bar v-if="vehicleTypes.length > 1">
              <v-toolbar-title>{{ $i18n.t("Vehicle Types") }}</v-toolbar-title>
            </v-app-bar>
            <v-row>
              <v-col cols="12" md="6">
                <z-vehicle-select class="purple-input" v-model="vehicle" idOnly multiple />
                {{vehicle}}
              </v-col>
            </v-row>

            <v-app-bar v-if="vehicleTypeGroup.length > 1">
              <v-toolbar-title>
                {{
                $i18n.t("Enabled Vehicle Categories")
                }}
              </v-toolbar-title>
            </v-app-bar>
            <v-row>
              <v-col cols="12" md="6"></v-col>
            </v-row>
          </v-container>
          <v-col cols="12" class="text-right">
            <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  corporateConfig = {
    vehicleTypes: [],
  };
  url = "/api/vtgroup/vehicle/category/map";
  vehicleTypeGroup = [];
  vehicleTypes = [];

  get loading() {
    return common.loading;
  }

  async updateVT(vt_id) {
    try {
      if (this.corporateConfig.vehicleTypes === undefined) {
        this.corporateConfig.vehicleTypes = [];
      }
      const idx = this.corporateConfig.vehicleTypes.indexOf(vt_id);
      if (idx > -1) {
        this.corporateConfig.vehicleTypes.splice(idx, 1);
      } else {
        this.corporateConfig.vehicleTypes.push(vt_id);
      }
    } catch (e) {
      common.setError(e);
    }
  }
  async mounted() {
    try {
      this.corporateConfig = await doGet("/api/corp/config/get");
    } catch (e) {
      common.setError(e.message);
    }
  }

  async save() {
    try {
      common.setLoading(true);
      // console.log(this.corporateConfig);
      await doPost("/api/corp/config/helpline/save", this.corporateConfig);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
